import styled from 'styled-components';
import colors from '../../../theme/Colors';
import theme from 'styled-theming';

interface TabItemProps {
    active: boolean;
}

const borderColor = theme('brand', {
    brenntag: colors.brenntag.secondary, 
    bcd: colors.bcd.primary
});

const textColor = theme('brand', {
    brenntag: colors.brenntag.primary, 
    bcd: colors.bcd.textColor
});

export const STabList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: inline-block;
`;

export const STabItem = styled.li<TabItemProps>`
    padding: 15px;
    background-color: ${props => props.active ? 'white' : 'transparent'};
    border-top-color: ${props => props.active && borderColor} !important;
    border-top: ${props => props.active ? '2px solid' : 'none'};
    display: inline-block;
    cursor: pointer;
    box-shadow: ${props => props.active ? '0 6px 0 #fff, 0 2px 4px 0 rgba(0, 0, 0, 0.05)' : 'none'};
    color: ${[props => props.active ? textColor : '#777777']};
`;